module.exports = __webpack_public_path__ + "196dd0d684746d776fa7c94506354844.svg";